import { render, staticRenderFns } from "./m_international_Communication_Capacity_Building.vue?vue&type=template&id=086204ee&scoped=true"
import script from "./m_international_Communication_Capacity_Building.vue?vue&type=script&lang=js"
export * from "./m_international_Communication_Capacity_Building.vue?vue&type=script&lang=js"
import style0 from "./m_international_Communication_Capacity_Building.vue?vue&type=style&index=0&id=086204ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086204ee",
  null
  
)

export default component.exports